import { v4 as uuid } from 'uuid';

import { PromoRequestItem } from '~/components/Promo/hooks/usePromoRequests';

import { PromoLog } from '~/services/PromoService';

/**
 * Parses promo logs into a standardized format of request items
 * @param promoLogs Array of promo logs to parse
 * @returns Array of standardized promo request items
 */
export const parsePromoRequestItemsFromPromoRequest = (promoLogs: Array<PromoLog>): Array<PromoRequestItem> => {
  return (
    promoLogs.flatMap((r) => {
      const items = r.details?.logResults?.inputOrder?.items || [];
      const deviceType = r.details?.logResults?.inputOrder?.deviceType;
      const mappedItems = items.map((item) => ({
        ...item,
        uniqueKey: uuid(),
        requestAt: r.created_at,
        isDeleted: r.deleted ? true : false,
        deviceType,
        codeName: r.code_name,
        orderId: r.fk_orders,
        currencyCode: r.currency,
        userId: r.used_by,
        fullRequest: r.details?.logResults?.inputOrder,
        discountItem: r.details.discountItems.find((di) => di.item.reqItem.itemId === item.itemId) ?? null,
      }));

      return mappedItems ?? [];
    }) ?? []
  );
};
